import GUSTHEME from './_GUS'
import BLACK_ON_YELLOW from './_BLACK_ON_YELLOW'
import YELLOW_ON_BLACK from './_YELLOW_ON_BLACK'

export const themes = {
    GUSTHEME,
    BLACK_ON_YELLOW,
    YELLOW_ON_BLACK
}

export default function getTheme(theme) {
    const themeFontSize = `${localStorage.getItem('appFontSize')}px` || '16px'
    document.getElementById('globalHtml').style.fontSize = themeFontSize;
    return themes[theme]
}
